
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EntityEspeciesCertificables } from "./entity-especies-certificables.model";
import { Observable, of } from "rxjs";
import { environment } from "projects/registro-personas-empresas/src/environments/environment";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class EntityEspeciesCertificablesService {
  endpoint = 'especiesCertificables';

  constructor(private http: HttpClient) { }

  getAll(): Observable<EntityEspeciesCertificables[]> {
    return this.http.get<EntityEspeciesCertificables[]>(`${environment.apiUrl}/${this.endpoint}/`)
      .pipe(
        catchError(() => {
          return of([
            {
              "id": 1803,
              "nombre_comun": "Achicoria",
              "nombre_cientifico": "Cichorium intybus",
              "id_cultivar": 31
            },
            {
              "id": 4924,
              "nombre_comun": "Alfalfa",
              "nombre_cientifico": "Medicago sativa",
              "id_cultivar": 104
            },
            {
              "id": 5467,
              "nombre_comun": "Arroz",
              "nombre_cientifico": "Oryza sativa",
              "id_cultivar": 117
            },
            {
              "id": 906,
              "nombre_comun": "Avena negra",
              "nombre_cientifico": "Avena strigosa",
              "id_cultivar": 12
            },
            {
              "id": 905,
              "nombre_comun": "Avena sativa",
              "nombre_cientifico": "Avena sativa",
              "id_cultivar": 11
            },
            {
              "id": 3898,
              "nombre_comun": "Cebada",
              "nombre_cientifico": "Hordeum vulgare",
              "id_cultivar": 82
            },
            {
              "id": 1260,
              "nombre_comun": "Cebadilla criolla",
              "nombre_cientifico": "Bromus catharticus",
              "id_cultivar": 20
            },
            {
              "id": 6991,
              "nombre_comun": "Centeno",
              "nombre_cientifico": "Secale cereale",
              "id_cultivar": 152
            },
            {
              "id": 1173,
              "nombre_comun": "Colza",
              "nombre_cientifico": "Brassica napus var. napus",
              "id_cultivar": 16
            },
            {
              "id": 1257,
              "nombre_comun": "Bromus auleticus",
              "nombre_cientifico": "Bromus auleticus",
              "id_cultivar": 19
            },
            {
              "id": 5764,
              "nombre_comun": "Falaris",
              "nombre_cientifico": "Phalaris aquatica",
              "id_cultivar": 127
            },
            {
              "id": 3219,
              "nombre_comun": "Festuca",
              "nombre_cientifico": "Festuca arundinacea",
              "id_cultivar": 75
            },
            {
              "id": 3214,
              "nombre_comun": "Festulolium",
              "nombre_cientifico": "×Festulolium braunii",
              "id_cultivar": 74
            },
            {
              "id": 3884,
              "nombre_comun": "Holcus",
              "nombre_cientifico": "Holcus lanatus",
              "id_cultivar": 81
            },
            {
              "id": 4672,
              "nombre_comun": "Lotus",
              "nombre_cientifico": "Lotus corniculatus",
              "id_cultivar": 92
            },
            {
              "id": 4677,
              "nombre_comun": "Lotus pedunculatus",
              "nombre_cientifico": "Lotus pedunculatus",
              "id_cultivar": 94
            },
            {
              "id": 4678,
              "nombre_comun": "Lotus rincón",
              "nombre_cientifico": "Lotus subbiflorus",
              "id_cultivar": 95
            },
            {
              "id": 4674,
              "nombre_comun": "Lotus tenuis",
              "nombre_cientifico": "Lotus tenuis",
              "id_cultivar": 93
            },
            {
              "id": 4725,
              "nombre_comun": "Lupino azul",
              "nombre_cientifico": "Lupinus angustifolius",
              "id_cultivar": 96
            },
            {
              "id": 8190,
              "nombre_comun": "Maíz",
              "nombre_cientifico": "Zea mays",
              "id_cultivar": 192
            },
            {
              "id": 7064,
              "nombre_comun": "Moha",
              "nombre_cientifico": "Setaria italica",
              "id_cultivar": 153
            },
            {
              "id": 1168,
              "nombre_comun": "Mostaza etíope",
              "nombre_cientifico": "Brassica carinata",
              "id_cultivar": 14
            },
            {
              "id": 5593,
              "nombre_comun": "Pasto bahía",
              "nombre_cientifico": "Paspalum notatum",
              "id_cultivar": 123
            },
            {
              "id": 5587,
              "nombre_comun": "Pasto miel",
              "nombre_cientifico": "Paspalum dilatatum",
              "id_cultivar": 121
            },
            {
              "id": 2466,
              "nombre_comun": "Pasto ovillo",
              "nombre_cientifico": "Dactylis glomerata",
              "id_cultivar": 52
            },
            {
              "id": 4612,
              "nombre_comun": "Raigrás anual",
              "nombre_cientifico": "Lolium multiflorum",
              "id_cultivar": 88
            },
            {
              "id": 4615,
              "nombre_comun": "Raigrás perenne",
              "nombre_cientifico": "Lolium perenne",
              "id_cultivar": 90
            },
            {
              "id": 3535,
              "nombre_comun": "Soja",
              "nombre_cientifico": "Glycine max",
              "id_cultivar": 77
            },
            {
              "id": 7317,
              "nombre_comun": "Sorgo",
              "nombre_cientifico": "Sorghum bicolor",
              "id_cultivar": 159
            },
            {
              "id": 12587,
              "nombre_comun": "Sorgo",
              "nombre_cientifico": "Sorghum bicolor x Sorghum ×drummondii",
              "id_cultivar": 201
            },
            {
              "id": 7320,
              "nombre_comun": "Sudangrás;",
              "nombre_cientifico": "Sorghum ×drummondii",
              "id_cultivar": 160
            },
            {
              "id": 7766,
              "nombre_comun": "Trigo",
              "nombre_cientifico": "Triticum aestivum",
              "id_cultivar": 175
            },
            {
              "id": 7780,
              "nombre_comun": "Triticale",
              "nombre_cientifico": "×Triticosecale",
              "id_cultivar": 176
            },
            {
              "id": 7688,
              "nombre_comun": "Trébol alejandrino",
              "nombre_cientifico": "Trifolium alexandrinum",
              "id_cultivar": 163
            },
            {
              "id": 7715,
              "nombre_comun": "Trébol blanco",
              "nombre_cientifico": "Trifolium repens",
              "id_cultivar": 170
            },
            {
              "id": 7716,
              "nombre_comun": "Trébol de Persia",
              "nombre_cientifico": "Trifolium resupinatum",
              "id_cultivar": 171
            },
            {
              "id": 7713,
              "nombre_comun": "Trébol rojo",
              "nombre_cientifico": "Trifolium pratense",
              "id_cultivar": 169
            },
            {
              "id": 8009,
              "nombre_comun": "Veza común",
              "nombre_cientifico": "Vicia sativa",
              "id_cultivar": 182
            },
            {
              "id": 8014,
              "nombre_comun": "Veza vellosa",
              "nombre_cientifico": "Vicia villosa",
              "id_cultivar": 183
            },
            {
              "id": 7998,
              "nombre_comun": "Vicia púrpura",
              "nombre_cientifico": "Vicia benghalensis",
              "id_cultivar": 181
            },
            {
              "id": 5390,
              "nombre_comun": "Esparceta;Pipirigallo",
              "nombre_cientifico": "Onobrychis viciifolia Scop.",
              "id_cultivar": 112
            },
            {
              "id": 902,
              "nombre_comun": "Avena brevis",
              "nombre_cientifico": "Avena brevis",
              "id_cultivar": 10
            },
            {
              "id": 1200,
              "nombre_comun": "Nabo",
              "nombre_cientifico": "Brassica rapa var rapa",
              "id_cultivar": 18
            },
            {
              "id": 3861,
              "nombre_comun": "Girasol",
              "nombre_cientifico": "Helianthus annuus",
              "id_cultivar": 80
            },
            {
              "id": 4565,
              "nombre_comun": "Lino",
              "nombre_cientifico": "Linum usitatissimum",
              "id_cultivar": 86
            },
            {
              "id": 4667,
              "nombre_comun": "Lotononis",
              "nombre_cientifico": "Lotononis bainesii Baker",
              "id_cultivar": 91
            },
            {
              "id": 6514,
              "nombre_comun": "Rábano;Rabanito",
              "nombre_cientifico": "Raphanus sativus L.",
              "id_cultivar": 146
            },
            {
              "id": 7729,
              "nombre_comun": "Trébol vesiculoso",
              "nombre_cientifico": "Trifolium vesiculosum Savi",
              "id_cultivar": 174
            }
          ])
        })
      )
  }

  add(item: EntityEspeciesCertificables): Observable<EntityEspeciesCertificables> {
    return this.http.post<EntityEspeciesCertificables>(`${environment.apiUrl}/${this.endpoint}/`, item);
  }

  delete(item: EntityEspeciesCertificables): Observable<EntityEspeciesCertificables> {
    return this.http.delete<EntityEspeciesCertificables>(`${environment.apiUrl}/${this.endpoint}/${item.id}/`);
  }

  update(item: EntityEspeciesCertificables): Observable<EntityEspeciesCertificables> {
    return this.http.patch<EntityEspeciesCertificables>(`${environment.apiUrl}/${this.endpoint}/${item.id}/`, item);
  }
}
